import React from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  Divider,
  Switch,
  FormControlLabel,
} from "@mui/material";
import { Notifications, Save } from "@mui/icons-material";

const NotificationsCard = ({
  notifications,
  onNotificationsChange,
  onSave,
}) => {
  return (
    <Box
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        p: 2.5,
        bgcolor: "background.paper",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
        <Notifications sx={{ color: "primary.main" }} />
        <Typography variant="subtitle1" fontWeight={600}>
          Notifications
        </Typography>
      </Box>
      <Divider sx={{ mb: 2 }} />

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <FormControlLabel
            control={
              <Switch
                checked={notifications.emailBackups}
                onChange={(e) =>
                  onNotificationsChange({
                    ...notifications,
                    emailBackups: e.target.checked,
                  })
                }
              />
            }
            label="Email me when backups complete"
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <FormControlLabel
            control={
              <Switch
                checked={notifications.emailUpdates}
                onChange={(e) =>
                  onNotificationsChange({
                    ...notifications,
                    emailUpdates: e.target.checked,
                  })
                }
              />
            }
            label="Email me about WordPress updates"
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <FormControlLabel
            control={
              <Switch
                checked={notifications.emailNews}
                onChange={(e) =>
                  onNotificationsChange({
                    ...notifications,
                    emailNews: e.target.checked,
                  })
                }
              />
            }
            label="Email me news and promotions"
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <FormControlLabel
            control={
              <Switch
                checked={notifications.smsAlerts}
                onChange={(e) =>
                  onNotificationsChange({
                    ...notifications,
                    smsAlerts: e.target.checked,
                  })
                }
              />
            }
            label="SMS alerts for critical issues"
          />
        </Grid>
      </Grid>

      <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
        <Button
          variant="contained"
          startIcon={<Save />}
          onClick={onSave}
          disableElevation
          sx={{ textTransform: "none", fontWeight: 600, borderRadius: 2 }}
        >
          Save Preferences
        </Button>
      </Box>
    </Box>
  );
};

export default NotificationsCard;
